module.exports = __webpack_public_path__ + "produce-fresh-grass-13.jpg?a30d0c2511c0c696c92f406a51891a12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-13.jpg
// module id = 50
// module chunks = 0